<template>
  <div class="leftNav">
    <div id="head_img">
      <div class="rightgo">
        <div class="directSend" v-if="isJgj === '1'">紧固件</div>
        <div v-else>
          <div class="directSend" v-if="shopType === '1'">直发</div>
          <div class="inDirectSend" v-if="shopType === '0'">平台</div>
          <div class="directSend" v-if="shopType === '2'">工厂</div>
        </div>
      </div>
    </div>
    <p class="login_name">{{user}}</p>
    <p class="shop-status">({{currenttype}})</p>
    <!-- <p class="login_info">欢迎登录!</p> -->
    <WebSocket v-if="token"></WebSocket>
  </div>
</template>
<script>
import WebSocket from '@/components/chat/webSocket/webSocket'
export default {
  data () {
    return {
      user: localStorage.getItem('username'),
      shopType: localStorage.getItem('shop_type'),
      token: localStorage.getItem('token'),
      isJgj:localStorage.getItem('is_jgj'),// 是否为紧固件
      activeIndex: '',
      currenttype: '',
    }
  },
  components: { WebSocket },
  mounted () {
    let enable = localStorage.getItem('is_enable')
    let status = localStorage.getItem('close_status')
    if (enable == '1') {
      this.currenttype = '开店'
    } else {
      if (status == '1') {
        this.currenttype = '关店'
      }
      if (status == '2') {
        this.currenttype = '停用'
      }
    }

    // 点击3次头像显示
    let btn = document.getElementById('head_img')
    let that = this
    this.nclickEvent(5, btn, function (event, n) {
      let roles = that.$store.getters.roles
      roles.push('click')
      that.$store.dispatch('user/avatarClick', roles)
    })
    // if (localStorage.getItem('activeIndex')) {
    //   console.log('activeIndex', localStorage.getItem('activeIndex'))
    //   this.activeIndex = localStorage.getItem('activeIndex')
    // }
  },
  methods: {
    nclickEvent (n, dom, fn) {
      dom.removeEventListener('dblclick', null)
      n = parseInt(n) < 1 ? 1 : parseInt(n)
      let count = 0
      let lastTime = 0
      let handler = function (event) {
        let currentTime = new Date().getTime()
        count = (currentTime - lastTime) < 300 ? count + 1 : 0
        lastTime = new Date().getTime()
        if (count >= n - 1) {
          fn(event, n)
          count = 0
        }
      }
      dom.addEventListener('click', handler)
    },
    rediret (item) {
      try {
        if (item.url === this.$route.path) {
          this.$router.push('/order/test') // 跳转页面想同则刷新当前页面
        } else {
          this.$router.push(item.url)
          this.activeIndex = item.index
          localStorage.setItem('activeIndex', item.index)
        }
      } catch (ex) {}
    },
    async showJzbMenu () {
      // let vm = this
      // setTimeout(function () {
      //   if (typeof vm.$store.getters.jzb_enable !== 'boolean') {
      //     vm.$store.dispatch('jzb/jzb_enable_change')
      //   }
      // }, 1000)
    }
  },
  created () {
    // this.showJzbMenu()
  }
}
</script>

<style lang="scss">
$commonFontSize: 14px;
.leftNav {
  margin-top: -10px;
  background-color: #303a43;
  #head_img {
    position: relative;
    width: 70px;
    height: 70px;
    margin-left: 50px;
    margin-top: 20px;
    top: 5px;
    border-radius: 50%;
    text-align: center;
    background: url(../../assets/img/default.jpg) no-repeat;
    background-size: 70px 70px;
    .rightgo {
      width: 50px;
      height: 15px;
      border-radius: 7px;
      overflow: hidden;
      position: absolute;
      bottom: -5px;
      left: 50%;
      font-size: 12px;
      line-height: 16px;
      color:#fff;
      transform: translateX(-50%);
      // img {
      //   width: 100%;
      //   height: 100%;
      // }
      .directSend {
        background-color: #1694FF;
      }
      .inDirectSend {
        background-color: #ff2e2e;
      }
    }
  }
  .login_name {
    color: rgb(191, 203, 217);
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    margin-top: 20px;
    // margin-left: -10px;
  }
  .login_info {
    color: rgb(191, 203, 217);
    text-align: center;
    font-size: 14px;
    margin-top:-10px;
    margin-bottom: 20px;
  }
  .shop-status{
    color: #fff;
    text-align: center;
    font-size: 10px;
    font-weight: bold;
    margin: 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Avatar.vue